<template>
  <li
    tag="li"
    class="sidemenu-item"
    :to="link.path ? link.path : '/'"
    :class="{ active: isActive }"
    :data-test="link.dataTest"
  >
    <div
      v-if="hasChild"
      data-toggle="collapse"
      class="parent-item"
      :class="{ active: isActive }"
      @click="itemClick(link)"
    >
      <i
        :class="link.icon"
        :style="`color: ${colors[index % 4]}`"
      />
      <p>
        {{ link.name }}
        <b
          v-if="link.children && link.children.length > 0"
          class="caret"
          :class="{ rotated: !collapsed }"
        />
      </p>
    </div>

    <router-link
      v-else
      :to="getLink(link)"
    >
      <i
        :class="link.icon"
        :style="`color: ${colors[index % colors.length]}`"
      />
      <p class="text-capitalize">
        {{ link.name }}
      </p>
    </router-link>

    <div
      v-show="!collapsed"
      v-if="hasChild"
      class="collapse-menu"
    >
      <ul class="nav">
        <li
          v-for="(child, childIndex) in link.children"
          :key="childIndex"
          :class="{ active: isChildActive(child) }"
          :target="child.target"
        >
          <router-link :to="getLink(child)">
            <span class="sidebar-mini-icon">{{ child.name.substring(0, 1) }}</span>
            <span class="sidebar-normal">{{ child.name }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </li>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import queryString from 'query-string';

import { useDashboard } from '@/use/app';
import { useCustomer } from '@/use/customer';

const colors = ['#ffc000', '#3a9efc', '#d673ff', '#b3bdc9'];

const props = defineProps({
  link: {
    type: Object,
    default: () => ({
      name: '',
      path: '',
      children: [],
    }),
    description: 'Link object',
  },

  index: {
    type: Number,
    default: 0,
  },
});

const route = useRoute();
const router = useRouter();

const { isOperatorDashboard, isPartnerDashboard } = useDashboard();
const { customerPhoneNumber } = useCustomer();

const collapsed = ref(true);
const hasChild = computed(() => props.link.children && props.link.children.length > 0);
const isActive = computed(() => {
  if (!route) {
    return false;
  }

  const matchingRoute = hasChild.value && props.link.children.find((c: any) => route.path.startsWith(c.path));

  if (matchingRoute !== undefined) {
    return true;
  }

  if (route.path.startsWith(props.link.path)) {
    return true;
  }

  return false;
});

const toggleMenu = () => (collapsed.value = !collapsed.value);

const getLink = (link: any) => {
  const queryParams = queryString.stringify({ phoneNumber: customerPhoneNumber.value });

  return customerPhoneNumber.value && (isOperatorDashboard.value || isPartnerDashboard.value) ? link.path + '?' + queryParams : link.path;
};

const itemClick = (link: any) => {
  if (link.children.length > 0) {
    toggleMenu();
  } else {
    router.push(getLink(link));
  }
};
const isChildActive = (link: any) => route.path === link.path;

watch(isActive, (value: boolean) => {
  if (value) {
    collapsed.value = false;
  }
});

collapsed.value = !isActive.value;
</script>

<style lang="scss">
.caret.rotated {
  transform: rotate(180deg);
}
.seperate-line {
  border-bottom: 1px dotted #dcdcdc;
  bottom: -5px;
  position: relative;
  margin: 5px 20px 15px;
}
.sidemenu-item {
  .parent-item {
    padding: 10px 8px 10px 0;
    margin: 10px 15px 0;
    text-align: left;
    font-size: 12px;
    color: #fff;
    opacity: 0.7;
    cursor: pointer;
    &:hover {
      opacity: 1;
    }
  }
  a {
    text-align: left;
  }
}
</style>
